var React = require('react');

function Heart (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10 3.22l-.61-.6a5.5 5.5 0 0 0-7.78 7.77L10 18.78l8.39-8.4a5.5 5.5 0 0 0-7.78-7.77l-.61.61z"}));
}

Heart.defaultProps = {"viewBox":"0 0 20 20"};

module.exports = Heart;

Heart.default = Heart;
